/*global window */
(function() {

  'use strict';
  navSito();
  
  $(window).scroll(function() {
    navSito();
  })

  function navSito() {
    var distanza = $(window).scrollTop();
    if (distanza > 100) {
      $('nav').addClass('fixed-top bg-navbar-fixed');
      $('#logo-colori').removeClass('d-none');
      $('#logo-bianco').addClass('d-none');
      $('.menu-sito').addClass('color-menu-dark un-sin-des');
      $('.menu-sito').removeClass('color-menu');
    } else {
      $('nav').removeClass('fixed-top bg-navbar-fixed');
      $('#logo-colori').addClass('d-none');
      $('#logo-bianco').removeClass('d-none');
      $('.menu-sito').addClass('color-menu');
      $('.menu-sito').removeClass('color-menu-dark un-sin-des');
    }
  }

      
  
}());
